export default {
  additionTypes: {
    once: 'Einmal',
    perPiece: 'Pro Stk',
    oncePerDocument: 'Einmal / Beleg'
  },
  addDocument: 'Beleg anlegen',
  documentsTodo: 'Offene Belege',
  documentPositions: 'Positionen',
  book: 'Buchen',
  bookingsDone: 'Getätitgte Buchungen',
  title: 'Ferkel',
  article: 'Artikel',
  articleAdd: 'Artikel anlegen',
  articleEdit: 'Artikel bearbeiten',
  base: 'Basis',
  destination: 'Bestimmung',
  collection: 'Sammelstelle',
  firstTransporter: 'Transport 1',
  secondTransporter: 'Transport 2',
  cancelReceipt: 'Stornieren',
  reOpenReceipt: 'Wieder öffnen',
  reOpend: 'Wiedergeöffnet',
  cancelReceiptRequest: 'Möchten Sie die Belege stornieren?',
  reOpenReceiptRequest: 'Möchten Sie die Belege wieder öffnen?',
  complete: 'Speichern und schließen',
  cannotDelete: 'Kann nicht gelöscht werden, bereits abgeschlossen!',
  chooseFattener: 'Bitte wählen eine Mäster',
  deleteAdditionQuest: 'Zu- Abschlag',
  info: 'Basisinformationen',
  addNew: 'Lieferschein anlegen',
  amount: 'Betrag',
  addition: 'Zu- Abschläge',
  additionValue: 'Zu- Abschlag',
  additionAdd: 'Zu- Abschlag anlegen',
  additionEdit: 'Zu- Abschlag bearbeiten',
  mode: 'Modus',
  deliveries: 'Lieferscheine',
  producer: 'Erzeuger',
  fattener: 'Mäster',
  basePrice: 'Basispreis',
  notices: 'Notizen',
  positions: 'Positionen',
  position: 'Pos',
  weight: 'Gew',
  transport: 'TS',
  transportAdd: 'Zu- Abschlag anlegen',
  transportEdit: 'Zu- Abschlag bearbeiten',
  pricePiece: '€ Stk',
  priceLot: '€ Partie',
  multiplicator: 'Mengenstaffel',
  multiplicatorShort: 'MS',
  multiplicatorPricePiece: 'Fix €',
  deliveryPrice: 'Diff Basis €',
  deliveryWeight: 'Basis kg',
  debitDateOffset: 'Rechnungsdatum verzögern um x Tage',
  additionPrice: 'Übergewicht €',
  additionWeight: 'Übergewicht kg',
  myco: 'Myco €',
  pcv2: 'PCV2 €',
  lotNumber: 'Partie-Nr.',
  marketingAddition: 'Verm. €',
  vaccination: 'Impfung',
  contractProducer: 'Lohn',
  incomingDate: 'Eingangsdatum',
  deliveryDate: 'Lieferdatum',
  pieces: 'Stk',
  totalWeight: 'Gesamtgewicht kg',
  avgWeight: 'Durchschnittsgewicht kg',
  avgWeightShort: 'Ø Gew',
  debitDate: 'Einzugsdatum der Rechnung (Mäster)',
  openPieces: 'Offene Stk',
  transactionDate: 'Überweisungsdatum der Gutschrift (Erzeuger)',
  transportCosts: 'TS €',
  transportType: 'TS Art',
  printProducer: 'Erzeuger drucken',
  printFattener: 'Mäster drucken',
  quantityFrom: "von",
  quantityTo: "bis",
  quantityScalePerLot: 'Mengenstaffel per Partie',
  quantityScalePerPiece: 'Mengenstaffel per Stück',
  om: 'OM',
  notice: 'Bemerkung',
  setPrices: 'Ferkelpreis aktualisieren',
  priceMode: 'Preismodus',
  priceModes: {
    addition: 'Zu- Abschlag',
    fix: 'Fix'
  },
  showPriceDetails: 'Preisdetail anzeigen',
  transportPriceModes: {
    perPiece: 'Per Stk',
    lumpSum: 'Pauschal'
  },
  priceMask: 'Preismaske',
  priceMaskCount: 'hinterlegte Preise',
  isDefault: 'Standard',
  marketingFee: 'Vermarktungsbeitrag',
  marketingFeeShort: 'Verm.',
  marketingFeeAdd: 'Vermarktungsbeitrag hinzufügen',
  marketingFeeEdit: 'Vermarktungsbeitrag bearbeiten',
  useQuantityScale: 'Mengenstaffel verwenden',
  price: 'Preis',
  unitPrice: 'Einzel',
  totalPrice: 'Gesamt',
  summary: 'Summe',
  deliveryCount: "Anzahl-Lieferungen",
  type: 'Typ',
  states: {
    todo: 'Offen',
    done: 'Abgeschlossen',
    register: 'Aus Einteilung',
    fromHire: 'Aus Einstallung'
  },
  paymentSlip: {
    title: "Erlagschein",
    from: "Rechnungsnr. von",
    to: "Rechnungsnr. bis",
    year: "Jahr",
  },
  notification: {
    complete: {
      type: 'success',
      message: 'Ferkellieferschein erfolgreich abgeschlossen',
      title: 'Erfolgreich abgeschlossen'
    },
    reOpen: {
      type: 'success',
      message: 'Ferkellieferschein erfolgreich wieder geöffnet',
      title: 'Erfolgreich abgeschlossen'
    },
    save: {
      type: 'success',
      message: 'Ferkellieferschein erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    },
    book: {
      type: 'success',
      message: 'Erfolgreich gebucht',
      title: 'Buchung erfolgreich gespeichert'
    },
    zsdb: {
      type: 'success',
      message: 'Erfolgreich gespeichert',
      title: 'ZSDB erfolgreich gespeichert'
    },
    manualDocument: {
      type: 'success',
      message: 'Erfolgreich gespeichert',
      title: 'Manuelles Dokument erfolgreich gespeichert'
    }
  }
}
